import { Button, Modal } from '../../components/common'
import { PendingPayment, cancelPendingPayment } from '../../api/payments'
import { trackEvent } from '../../lib/config'
import { hcCurrency } from '../../lib/currency'
import styles from './PendingPaymentModal.module.scss'

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="col-xs-12">
      <div className="col-xs-3 col-xs-offset-1">
        <p className="bold">{label}</p>
      </div>
      <div className="col-xs-6">
        <p>{value}</p>
      </div>
    </div>
  )
}

export function PendingPaymentModal({ payment, onDismiss }: { payment: PendingPayment; onDismiss: () => void }) {
  const dismiss = () => {
    trackEvent('Pending Payment Dismissed', { amount: payment.amount })
    onDismiss()
  }

  const cancel = async () => {
    try {
      await cancelPendingPayment(payment.cancel_path)
    } catch {
      // api.ts has already emitted API Error; the modal stays open so the
      // professional sees the payment is still pending.
      return
    }
    trackEvent('Pending Payment Cancelled', { amount: payment.amount })
    onDismiss()
  }

  return (
    <Modal
      open
      onClose={dismiss}
      id="continue-pending-payment"
      header={<h5 className="modal-title">Pago pendiente encontrado</h5>}
      footer={
        <>
          <div className="col-xs-2 col-xs-offset-4">
            <Button id="cancel-payment" variant="secondary" className={styles.answer} onClick={() => void cancel()}>
              No
            </Button>
          </div>
          <div className="col-xs-2">
            <Button
              id="continue-payment"
              className={styles.answer}
              onClick={() => {
                trackEvent('Pending Payment Resumed', { amount: payment.amount }, { transport: 'sendBeacon' })
                window.location.assign(payment.flow_url ?? '')
              }}
            >
              Si
            </Button>
          </div>
        </>
      }
    >
      <p>Encontramos un pago que aún no ha sido completado</p>
      <br />
      <div className="col-xs-12">
        <Field label="ID" value={payment.title ?? ''} />
        <Field label="Monto" value={hcCurrency(payment.amount)} />
        <Field label="Descripción" value={payment.description ?? ''} />
      </div>
      <br />
      <br />
      <p className={styles.question}>¿Deseas retomar este pago?</p>
    </Modal>
  )
}
